'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  slide: require('./menus/slide'),
  stack: require('./menus/stack'),
  elastic: require('./menus/elastic'),
  bubble: require('./menus/bubble'),
  push: require('./menus/push'),
  pushRotate: require('./menus/pushRotate'),
  scaleDown: require('./menus/scaleDown'),
  scaleRotate: require('./menus/scaleRotate'),
  fallDown: require('./menus/fallDown'),
  reveal: require('./menus/reveal')
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/BurgerMenu.js
// module id = 586
// module chunks = 114276838955818